<template>
  <div class="home">
    <div class="bg">
      <img class="back-home" @click="backHome" src="@/assets/img/home_icon.png" alt="">
      <div class="logo" v-if="unionLogo && unionLogo.logo">
        <img :src="unionLogo.logo" v-if="unionLogo.type === 1">
        <h1 v-else>{{unionLogo.logo}}</h1>
      </div>
      <div class="content">
        <div class="title">{{error ? error : "请选择你想要领取的考试"}}</div>
        <div class="line"></div>
        <div class="box" v-for="i in courseClass" :key="i.ExamdaClassID">
          <div class="name">{{i.ClassCName}}</div>
          <div class="as">
            <router-link v-for="ii in i.Children" :key="ii.ExamdaClassID" :to="{ path: 'exam', query: { id: ii.ExamdaClassID, promoteCode: promoteCode }}">{{ii.ClassCName}}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetUnionLogoByPromote, GetLoginStatus, GetCourseClassByHost } from "../../lib/request"
export default {
  name: "Home",
  data() {
    return {
      promoteCode: "",
      unionLogo: {},
      courseClass: [],
      error: ""
    }
  },
  created() {
    if (this.$route.query.promoteCode) {
      this.promoteCode = this.$route.query.promoteCode
    } else {
      location.href = "https://v.233.com/"
    }
    this.GetUnionLogoByPromote()
    this.GetCourseClassByHost()
  },
  mounted() {
    this.GetLoginStatus()
  },
  methods: {
    backHome() {
      location.href = window.location.origin + "/m/fine/new"
    },
    GetLoginStatus() {
      if (window.location.href.indexOf("v.233.com") > -1) {
        document.title = "领课"
      } else {
        GetLoginStatus({}, (res) => {
          const { Result } = res
          document.title = Result.webName ? "领课-" + Result.webName : "领课"
        })
      }
    },
    GetUnionLogoByPromote() {
      GetUnionLogoByPromote({ promoteCode: this.promoteCode }, (res) => {
        const { Result } = res
        this.unionLogo = Result
      })
    },
    GetCourseClassByHost() {
      GetCourseClassByHost({ promoteCode: this.promoteCode }, (res) => {
        if (res.ResultDescription) {
          this.error = res.ResultDescription
        } else {
          this.courseClass = res.Result
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home{
  height: 100%;
  .bg{
    width: 100%;
    background: url("https://img2.233.com/wx/union/wap/leadaclass/home-bg.jpg") no-repeat top center;
    background-size: 100%;
    position: relative;
    padding: 48% 10px 25px;
    box-sizing: border-box;
    background-color: #FDDEE0;
    min-height: 100%;
    .back-home {
      width: 36px;
      height: 36px;
      top: 10px;
      right: 10px;
      position: absolute;
    }
    .logo{
      position: absolute;
      top: 0;
      left: 24px;
      height: 36px;
      background: #FFFFFF;
      border-radius: 0px 0px 10px 10px;
      padding: 7px 12px;
      box-sizing: border-box;
      img{
        height: 22px;
      }
      h1{
        font-size: 14px;
        color: #333;
      }
    }
    .content{
      background: #FFFFFF;
      box-shadow: 0px 0px 15px 0px rgba(219, 219, 219, 0.4);
      border-radius: 10px;
      padding: 25px 0;
      .title{
        font-size: 20px;
        color: #000;
        line-height: 20px;
        text-align: center;
        font-weight: 800;
        z-index: 2;
        position: relative;
      }
      .line{
        width: 232px;
        height: 8px;
        background: #FDDEE0;
        opacity: .5;
        margin: -6px auto 0;
        z-index: 1;
        position: relative;
      }
      .box{
        padding: 25px 14px 0;
        .name{
          font-size: 16px;
          color: #333;
          line-height: 24px;
          font-weight: 800;
        }
        .as{
          a{
            margin: 13px 9px 0 0;
            display: inline-block;
            width: 100px;
            height: 30px;
            line-height: 28px;
            border: 1px solid #EBEBEB;
            border-radius: 15px;
            box-sizing: border-box;
            color: #333;
            font-size: 13px;
            text-align: center;
            text-decoration: none;
          }
        }
      }
    }
  }
}
</style>